import { AutogenLayoutOfficePendingPayAdjustmentsReport } from "./autogen/AutogenLayoutOfficePendingPayAdjustmentsReport";

export class OfficePendingPayAdjustmentsReport extends AutogenLayoutOfficePendingPayAdjustmentsReport {
    override onLoad(): void {
        super.onLoad();

        // Initialize group by dropdown with first item selected
        if (this.textboxGroupBy.items && this.textboxGroupBy.items.length > 0) {
            this.textboxGroupBy.selectedItem = this.textboxGroupBy.items[0];
        }
    }

    checkboxIncludeSettlementsOnChange() {
        const includeSettlements = this.checkboxIncludeSettlementPayAdjustments.checked;

        // Enable/disable payee type dropdown based on include settlements
        this.textboxPayeeType.enabled = includeSettlements;

        this.excludabletextboxPayees.textbox.clear();
        if(includeSettlements) {
            this.excludabletextboxPayees.textbox.lookupModel = "lme/settlement/transfer-to-settlement-payee";
            this.excludabletextboxPayees.textbox.lookupModelLayout = "lme/settlement/TransferToSettlementPayeeLookup";
        }
        else {
            // Clear payee type when include settlements is unchecked
            this.textboxPayeeType.clear();
            this.excludabletextboxPayees.textbox.lookupModel = "lme/settlement/officepayroll/off-payee";
            this.excludabletextboxPayees.textbox.lookupModelLayout = "lme/settlement/officepayroll/OfficePayeeLookup";
        }
    }
}
